<template>
  <parent>
    <div>
      <div class="mb-2">
        <b-button
          variant="bg-white"
          class="shadow"
          @click="$router.push({ name: 'live-hubs' })"
        >
          <GjIcon name="ArrowLeft" />
          Back
        </b-button>
      </div>
      <loading-page v-if="gettingLiveHub && !!!liveHubData" />
      <div
        v-else
        class="live-hub-settings"
      >
        <paper>
          <template v-slot:title>
            <p class="mb-0">
              Overview
            </p>
            <a
              v-clipboard:copy="liveHubData.name"
              v-clipboard:success="copySuccess"
              class="d-flex align-items-center cursor-pointer fit-content"
            >
              <span>{{ liveHubData.name }}</span>
              <span
                class="text-secondary"
                style="margin-left: 13px"
              >
                <GjIcon
                  name="Copy"
                  size="20"
                />
              </span>
            </a>
          </template>
          <div class="px-2">
            <div class="mb-1">
              <div class="d-flex justify-content-between align-items-center flex-wrap">
                <div
                  class="position-relative hub-status"
                  :class="hubStatusClass"
                >
                  {{
                    getObjectOptionsText(
                      liveHubData.liveJobStatusType,
                      liveHubData.status,
                    )
                  }}
                  <b-icon-circle-fill
                    :animation="playerAvailable ? 'throb' : ''"
                  />
                </div>
                <div class="d-flex justify-content-end">
                  <b-button
                    v-if="playerAvailable"
                    variant="bg-white"
                    class="ml-2"
                    :disabled="settingTranscodingStatus"
                    @click="updateTranscoding"
                  >
                    {{ liveHubData.status === liveHubData.liveJobStatusType.Live ? 'Stop' : 'Start' }}
                    <GjIcon
                      :key="`${liveHubData.liveJobStatusType.Live}${settingTranscodingStatus}${gettingLiveHub}`"
                      class="icon-right"
                      :name="transcodingStatusIcon"
                    />
                  </b-button>

                  <b-button
                    variant="bg-white"
                    class="ml-2"
                    :disabled="gettingLiveHub"
                    :class="[liveHubData.status === liveHubData.liveJobStatusType.Completed ? 'd-none' : '']"
                    @click="fetchLiveHub"
                  >
                    Refresh
                    <GjIcon
                      class="icon-right"
                      name="Refresh"
                    />
                  </b-button>
                </div>
              </div>

              <div
                class="pt-2 row"
                :class="[liveHubData.status === liveHubData.liveJobStatusType.Completed ? 'd-none' : '']"
              >
                <div class="col-12 col-md-7 col-lg-7 mb-2 mb-md-0">
                  <div
                    class="d-flex label-text justify-content-between flex-wrap"
                  >
                    <span class="">Playback Preview</span>
                  </div>
                  <div
                    v-if="liveHubData.status === liveHubData.liveJobStatusType.Live && liveHubData.record"
                    style="position:absolute;top:30px;right:18px;z-index:100;padding:4px"
                  >
                    <b-icon-record-circle
                      animation="throb"
                      style="color:red"
                    />
                    <span style="color:red;font-weight:semi-bold;font-size:13px">Recording</span>
                  </div>
                  <vp-player
                    :file-path="filePathComputed"
                    player-id="vp-player"
                    class="shadow"
                    :is-live="true"
                  />
                </div>
                <div
                  class="col-12 col-md-5 col-lg-5 d-flex flex-column"
                  style="height:400px;"
                >
                  <job-statistics
                    :stats="hubStatistics"
                    :active="playerAvailable"
                    :loading="gettingLiveHub"
                    @refresh="fetchLiveHub"
                  />
                </div>
              </div>
            </div>

            <paper class="inner-paper">
              <template v-slot:title>
                <p class="mb-0">
                  Details
                </p>
              </template>
              <div class="row">
                <div class="col-12 col-lg-12">
                  <!-- <b-form-group
                    class="details mb-0"
                    label="Primary Endpoint"
                    label-cols="12"
                    label-cols-md="2"
                  >
                    <a
                      v-clipboard:copy="primaryEndpoint"
                      v-clipboard:success="copySuccess"
                      class="
                        d-flex
                        align-items-center
                        cursor-pointer
                        fit-content
                      "
                    >
                      <span>{{ primaryEndpoint }}</span>
                      <span
                        class="text-secondary"
                        style="margin-left: 13px"
                      >
                        <GjIcon
                          name="Copy"
                          size="20"
                        />
                      </span>
                    </a>
                  </b-form-group> -->
                  <b-form-group
                    class="details mb-0"
                    label="Stream Key"
                    label-cols="12"
                    label-cols-md="2"
                  >
                    <text-hidden
                      :show-password="showPassword"
                      :text="liveHubKey"
                      white-background
                      @toggle="showPassword = !showPassword"
                    />
                  </b-form-group>

                  <b-form-group
                    class="details mb-0"
                    label="Template Name"
                    label-cols="12"
                    label-cols-md="2"
                  >
                    <router-link :to="{ name: 'job-templates-view', params: { id: liveHubData.jobTemplateId, projectId: $route.params.projectId }}">
                      <span>{{ liveHubData.jobTemplateName || '-' }} </span>
                    </router-link>
                    <span
                      class="text-secondary"
                      style="margin-left: 13px"
                    >
                      <GjIcon
                        name="Redirect"
                        size="20"
                      />
                    </span>
                  </b-form-group>

                  <b-form-group
                    v-if="liveHubData.record"
                    class="details mb-0"
                    label="Record Type"
                    label-cols="12"
                    label-cols-md="2"
                  >
                    <a
                      class="
                        d-flex
                        align-items-center
                        cursor-pointer
                        fit-content
                      "
                    >
                      <span>{{ liveHubData.recordType === 0 ? 'Record All' : 'Record Hourly' }}</span>
                    </a>
                  </b-form-group>
                </div>
              </div>
            </paper>

            <collapsable
              class="collapsable"
              header-class="px-0"
              title="Live Jobs"
            >
              <template>
                <live-jobs
                  is-from-live-hub
                  @onGetLiveJobs="onLiveJobChange"
                />
              </template>
            </collapsable>

            <collapsable
              class="collapsable"
              header-class="px-0"
              title="Output Groups"
            >
              <template v-if="liveHubData.groups && liveHubData.groups.length > 0">
                <output-group
                  v-for="(group, index) in liveHub.groups"
                  :key="index"
                  :group="group"
                />
              </template>
              <template v-else>
                No output groups available.
              </template>
            </collapsable>

            <collapsable
              class="collapsable"
              title="Restreams"
            >
              <restreams />
            </collapsable>

            <collapsable
              class="collapsable"
              title="Tags"
            >
              <b-table
                ref="table"
                :items="liveHubData.tags"
                show-empty
                :fields="fields"
                responsive
                class="loaded border-default border-b border-r border-l rounded"
              />
            </collapsable>

            <!-- <collapsable
              ref="timingLogsCollapse"
              class="collapsable"
              :class="{ 'mb-1': !liveHub.record }"
              title="Timing Logs"
            >
              <template v-slot:default="{ visible }">
                <general-timing-logs :visible="visible" />
              </template>
            </collapsable> -->

            <collapsable
              v-if="liveHub.record"
              class="collapsable"
              :class="{ 'mb-1': liveHub.record }"
              title="Records"
            >
              <b-table
                ref="table"
                :items="liveHub.records"
                show-empty
                :fields="recordFields"
                responsive
                class="loaded border-default border-b border-r border-l rounded"
              >
                <template #cell(path)="data">
                  <a
                    v-if="data.item.uploaded"
                    class="link"
                    @click="openStorageRecords(data.value)"
                  >
                    {{ data.value }}
                    <GjIcon
                      name="Redirect"
                      size="20"
                    />
                  </a>
                  <span v-else>{{ data.value }}</span>
                </template>
              </b-table>
            </collapsable>

            <collapsable
              class="mb-1 collapsable"
              title="Authorization"
            >
              <encoder-authorization-settings v-model="liveHub" />

              <div class="d-flex justify-content-end">
                <button-loading
                  :spinning="updatingLiveHub"
                  :disabled="updatingLiveHub"
                  variant="bg-primary"
                  @click="updateHub"
                >
                  Update
                </button-loading>
              </div>
            </collapsable>
          </div>
        </paper>
      </div>
    </div>
  </parent>
</template>
<script>
import {
  BIconRecordCircle,
  BIconCircleFill,
} from 'bootstrap-vue'
import Paper from '@/components/paper/Paper.vue'
import Collapsable from '@/components/Collapsable.vue'
import TextHidden from '@/components/text/TextHidden.vue'
import VpPlayer from '@/components/vp-player/Player.vue'
import EncoderAuthorizationSettings from '@/components/views/encoder/EncoderAuthorizationSettings.vue'
import redirectError from '@/services/redirectError'
import JobStatistics from '../live-encoder/settings/JobStatistics.vue'
import OutputGroup from '../live-encoder/settings/helpers/OutputGroup.vue'
import LiveJobs from '../live-encoder/LiveEncoder.vue'
import Restreams from '../restreams/Restreams.vue'

export default {
  name: 'LiveHubSetting',
  components: {
    Paper,
    JobStatistics,
    BIconCircleFill,
    Collapsable,
    BIconRecordCircle,
    OutputGroup,
    LiveJobs,
    Restreams,
    TextHidden,
    VpPlayer,
    EncoderAuthorizationSettings,
  },
  data() {
    return {
      hubName: '',
      liveHubData: null,
      playerReady: false,
      showKey: false,
      fields: ['key', 'value'],
      recordFields: ['path'],
      showPassword: false,
      showCutControls: false,
    }
  },
  computed: {
    playerAvailable() {
      if (!this.liveHub.status) {
        return false
      }
      return (
        this.liveHub.status === this.liveHub.liveJobStatusType.Live
        || this.liveHub.status
          === this.liveHub.liveJobStatusType.Processing
      )
    },
    // destinationStatus() {
    //   if (!this.liveHub) return false
    //   return (
    //     this.liveHub.status
    //       === this.liveHub.liveJobStatusType.Pending
    //     || this.liveHub.status
    //       === this.liveHub.liveJobStatusType.Processing
    //   )
    // },
    getMasterFilePath() {
      const foundGroup = this.liveHub.groups.find(group => group.name === 'hls' || group.name === 'AppleHLS')
      return foundGroup ? foundGroup.masterFilePath : null
    },
    filePathComputed() {
      return this.getMasterFilePath || null
    },
    gettingLiveHub() {
      return this.$store.state.liveHubs.gettingLiveHub
    },
    updatingLiveHub() {
      return this.$store.state.liveHubs.updatingLiveHub
    },
    liveHub() {
      return this.$store.state.liveHubs.liveHub
    },
    liveHubUrl() {
      if (this.liveHub.flvDisplay !== '') {
        return this.liveHub.flvDisplay
      }
      return null
    },
    liveHubKey() {
      if (this.liveHub?.key) {
        return this.liveHub.key.toUpperCase()
      }
      return '-'
    },
    // primaryEndpoint() {
    //   return this.liveHub ? this.liveHub.primaryEndpoint : null
    // },
    // storageMasterFile() {
    //   return this.liveHub ? this.liveHub.storageMasterFile : null
    // },
    hubStatistics() {
      if (this.liveHub?.statistics) {
        return this.liveHub.statistics
      }
      return null
    },
    // location() {
    //   return this.liveHub ? this.liveHub.records.path : null
    // },
    // destination() {
    //   return this.liveHub?.destination || null
    // },
    hubStatusClass() {
      if (
        this.liveHub?.status
          === this.liveHub?.liveJobStatusType.Pending
        || this.liveHub?.status
          === this.liveHub?.liveJobStatusType.Processing
      ) {
        return 'text-warning'
      }
      if (
        this.liveHub?.status === this.liveHub?.liveJobStatusType.Live
      ) {
        return 'text-success'
      }
      if (
        this.liveHub?.status
          === this.liveHub?.liveJobStatusType.Offline
        || this.liveHub?.status
          === this.liveHub?.liveJobStatusType.NotApplicable
        || this.liveHub?.status === this.liveHub?.liveJobStatusType.Error
      ) {
        return 'text-danger'
      }
      return ''
    },
    settingTranscodingStatus() {
      return this.$store.state.liveHubs.settingTranscodingStatus
    },
    transcodingStatusIcon() {
      if (this.settingTranscodingStatus) return 'LoaderAlt'
      return this.liveHub.status === this.liveHub.liveJobStatusType.Live
        ? 'Stop_fill'
        : 'Play_fill'
    },
  },
  created() {
    this.hubName = this.$route.params.liveHubName
    this.fetchLiveHub()

    this.$store.dispatch('organization/fetchCountries').catch(error => {
      this.errorToast(
          error.response?.data?.errors?.toString() || 'Something went wrong while fetching countries',
      )
    })
  },
  methods: {
    onLiveJobChange() {
      this.fetchLiveHub()
    },
    // trimmVideo(va) {
    //   this.isHidden = va
    // },
    fetchLiveHub() {
      this.$store
        .dispatch('liveHubs/getLiveHubV2', this.hubName)
        .then(res => {
          this.liveHubData = res.data?.result
        })
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    updateTranscoding() {
      const version = this.liveHubData.livestreamProvider === 1 ? '' : 'V2'
      this.$store
        .dispatch('liveHubs/updateTranscoding', { name: this.hubName, version })
        .then(() => {
          this.fetchLiveHub()
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while updating transcoding status.',
          )
        })
    },
    openStorageRecords(url) {
      const link = new URL(url)
      const path = link.pathname
      this.openStorage(path.toString().slice(1, path.length))
    },
    openStorage(dest) {
      if (dest) {
        const temp = dest.split('/')
        const bucket = temp[0]
        let key = `${temp.slice(1, temp.length).join('/')}${
          temp.length > 1 ? '/' : ''
        }`
        const regEx = /^[\w,\s-]+\.[A-Za-z]+$/
        if (regEx.test(temp[temp.length - 1])) {
          key = key.slice(0, key.length - 1)
        }
        const destination = this.$router.resolve({
          name: 'object-files',
          params: {
            projectId: this.$route.params.projectId,
            id: bucket,
          },
          query: regEx.test(temp[temp.length - 1])
            ? {
              key,
              tab: 0,
            }
            : {
              key,
            },
        })
        window.open(destination.href, '_blank')
      }
    },

    updateHub() {
      const query = {
        liveHubName: this.liveHub.name,
        liveHub: {
          playbackAuthorizationEndpoint: this.liveHub.playbackAuthorizationEndpoint,
          allowedCountries: this.liveHub.allowedCountries,
          disallowedCountries: this.liveHub.disallowedCountries,
        },
      }
      this.$store
        .dispatch('liveHubs/modifyLiveHub', query)
        .then(() => {
          this.successToast('Live Hub was updated')
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors?.toString() || 'Something went wrong while updating live hub.')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.live-hub-settings {
  max-width: 1920px;
  margin: auto;

  .inner-paper::v-deep {
    .card-header {
      padding: 16px 0;
    }
  }
  .details::v-deep {
    .form-row {
      align-items: center;
    }
  }
}
.shadow{
  box-shadow: rgba(149, 157, 165, 0.2) 0px 4px 16px !important;
}
.label-text {
  margin-bottom: 8px;
  color: #667c99;
}
.info-box {
  height: calc(100% - 32px);
  padding: 12px;
}
.hub-status {
  display: flex;
  align-items: center;
  svg {
    margin-left: 5px;
    font-size: 7px;
  }
}
.private-key {
  position: relative;
  span {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: var(--white);
  }
}
.fit-content {
  width: fit-content;
}

.collapsable::v-deep {
  .card-header {
    padding: 16px 0 !important;
  }
  .collapse {
    .card-body {
      padding: 16px 0 !important;
    }
  }
}
</style>
